import React, { useEffect, useState } from "react";
import "../Styles/style.css";
import listIcon from "../Asstes/Images/lists-icon.svg";
import config from "../config";

const BANNER_API = `${config.API_BASE_URL}/banners/learning-and-development`;

const CONTENT_API = `${config.API_BASE_URL}/content/learning-and-development`;

const LearningDevelopmentPage = () => {
  const [bannerData, setBannerData] = useState(null);
  const [contents, setContents] = useState([]);

  useEffect(() => {
    fetch(BANNER_API)
      .then((res) => res.json())
      .then((data) => {
        if (data?.banners?.length > 0) {
          setBannerData(data.banners[0]);
        }
      })
      .catch((err) => console.error("Banner fetch error:", err));

    fetch(CONTENT_API)
      .then((res) => res.json())
      .then((data) => {
        if (data?.content?.length > 0) {
          setContents(data.content);
        }
      })
      .catch((err) => console.error("Content fetch error:", err));
  }, []);

  // Find section 2 & 3 data so we can render them in one section
  const section2 = contents.find((item) => item.content_order === "2");
  const section3 = contents.find((item) => item.content_order === "3");

  return (
    <>
      {/* Banner Section */}
      <section
        className="learning-banner learning-mobile"
        style={{
          backgroundImage: bannerData
            ? `url(/prosapiens-cms/public/${bannerData.banner_image})`
            : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="overlay container">
          <div className="hero-text">
            {bannerData ? (
              <>
                <h1>{bannerData.banner_title}</h1>
                <p
                  style={{ color: "#fff" }}
                  dangerouslySetInnerHTML={{
                    __html: bannerData.content_text,
                  }}
                />
              </>
            ) : (
              <h1>Loading Banner...</h1>
            )}
          </div>
        </div>
      </section>

      {/* Section 1 - Training & Development */}
      {contents.map((item) => {
        if (item.content_order === "1") {
          const imageUrl = `/prosapiens-cms/public/${item.content_image}`;
          return (
            <section className="what-we-do" key={item.id}>
              <div className="container">
                <div className="image-container">
                  <div className="image-side" data-aos="fade-right">
                    <img src={imageUrl} alt="Content Image" />
                  </div>
                  <div className="text-side" data-aos="fade-left">
                    {item.content_text && (
                      <div
                        dangerouslySetInnerHTML={{ __html: item.content_text }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </section>
          );
        }
        return null;
      })}

      {/* Sections 2 & 3 combined */}
      {(section2 || section3) && (
        <section className="lermimg-dev-bg">
          <div className="container">
            {section2 && (
              <div className="text-for-leraning">
                <div className="image-container">
                  <div className="image-side" data-aos="fade-right">
                    <img
                      src={`/prosapiens-cms/public/${section2.content_image}`}
                      alt="Content Image"
                    />
                  </div>
                  <div className="text-side" data-aos="fade-left">
                    {section2.content_text && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: section2.content_text,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}

            {section3 && (
              <div className="text-lean-img">
                <div className="image-container">
                  <div className="text-side" data-aos="fade-left">
                    {section3.content_text && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: section3.content_text,
                        }}
                      />
                    )}
                  </div>
                  <div className="image-side" data-aos="fade-right">
                    <img
                      src={`/prosapiens-cms/public/${section3.content_image}`}
                      alt="Content Image"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default LearningDevelopmentPage;
